import { Observable } from 'rxjs';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, forwardRef, HostBinding, Input, OnDestroy, Optional, Self } from '@angular/core';
import { ControlValueAccessor, NgControl, Validators } from '@angular/forms';
import { MatFormFieldControl } from '@angular/material/form-field';
import { Subject } from 'rxjs';
import { ClientBonus } from 'src/app/commons/models/client-bonus.model';

export const CLIENT_BONUSES_FIELD_MAT_FORM_FIELD_CONTROL: any = {
  provide: MatFormFieldControl,
  useExisting: forwardRef(() => ClientBonusesFieldComponent),
};

@Component({
  selector: "app-client-bonuses-field",
  templateUrl: "./client-bonuses-field.component.html",
  styleUrls: ["./client-bonuses-field.component.scss"],
  providers: [CLIENT_BONUSES_FIELD_MAT_FORM_FIELD_CONTROL],
  host: {
    "[class.floating]": "shouldLabelFloat",
    "[id]": "id",
  },
})
export class ClientBonusesFieldComponent
  implements OnDestroy, ControlValueAccessor, MatFormFieldControl<ClientBonus[]> {
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  private unsubscribe$ = new Subject<void>();

  private _value: ClientBonus[] = [];
  private _disabled = false;
  openEdit: boolean;
  currentClientBonusIndex: number;

  private _required = false;


  get errorState(): boolean {
    return !this.ngControl.valid;
  }
  focused: boolean; //TODO
  controlType?: string = "client-bonus-selection-field";
  autofilled?: boolean;
  clientBonusAriaDescribedBy?: string;


  constructor(
    @Optional() @Self() public ngControl: NgControl,
  ) {
    if (this.ngControl != null) {
      this.ngControl.valueAccessor = this;
    }
  }

  ngOnInit() { }

  get currentClientBonus(): ClientBonus {
    if (this.currentClientBonusIndex >= 0)
      return this.value.at(this.currentClientBonusIndex);
    return null;
  }

  open() {
    this.openEdit = true;
  };

  close() {
    this.openEdit = false;
  }

  addClientBonus() {
    this.currentClientBonusIndex = -1;
    this.open();
  }

  editClientBonus(index: number) {
    this.currentClientBonusIndex = index;
    this.open();
  }

  save(clientBonus: ClientBonus) {
    if (this.currentClientBonusIndex >= 0) {
      this._value[this.currentClientBonusIndex] = clientBonus;
      this.currentClientBonusIndex = -1;
    } else {
      this._value.push(clientBonus);
    }

    this.notifyValueChange();
  }

  removeClientBonus(index: number) {
    if (this.currentClientBonusIndex === index) {
      this.currentClientBonusIndex = -1;
      this.close();
    }

    this.value.splice(index, 1);
    this.notifyValueChange();
  }

  stateChanges = new Subject<void>();
  id: string;

  @Input()
  get placeholder() {
    return this._placeholder;
  }
  set placeholder(plh) {
    this._placeholder = plh;
    this.stateChanges.next();
  }
  private _placeholder: string;

  get empty() {
    return !this.value;
  }

  @HostBinding("class.floating")
  get shouldLabelFloat() {
    return this.focused || !this.empty;
  }

  get required() {
    return this._required || this.ngControl?.control?.hasValidator(Validators.required) || false;
  }

  @Input()
  set required(req) {
    this._required = coerceBooleanProperty(req);
    this.stateChanges.next();
  }

  get disabled(): boolean {
    return this._disabled;
  }

  @Input()
  set disabled(value: boolean) {
    this._disabled = coerceBooleanProperty(value);
    this.stateChanges.next();
  }

  setDescribedByIds(ids: string[]): void {

  }

  onContainerClick(event: MouseEvent): void {

  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    this.stateChanges.complete();
  }

  @Input()
  set value(value: ClientBonus[]) {
    this._value = value;
    this.notifyValueChange();
    this.stateChanges.next();
  }

  get value(): ClientBonus[] {
    return this._value;
  }

  onChange: (value) => {};
  onTouched: () => {};

  notifyValueChange(): void {
    if (this.onChange) {
      this.onChange(this.value);
    }
  }

  writeValue(obj: ClientBonus[]): void {
    this.value = [];
    if (obj) {
      this.value.push(...obj);
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
